import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';


export class AppRouteCache implements RouteReuseStrategy {
  public static handlers: { [key: string]: DetachedRouteHandle } = {};

  public shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route.routeConfig.data?.reuse ?? false;
  }

  public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    AppRouteCache.handlers[this.getKey(route)] = handle;
  }

  public shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return (
      !!route.routeConfig && !!AppRouteCache.handlers[this.getKey(route)]
    );
  }

  public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    if (!route.routeConfig) {
      return null;
    }
    return AppRouteCache.handlers[this.getKey(route)];
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === current.routeConfig;
  }

  private getKey(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .filter(snap => snap.url.length > 0)
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');
  }
}
